import axios from 'axios';

const AxioInstance = axios.create({
    /*  baseURL: 'http://localhost:3000', */
});

AxioInstance.interceptors.request.use(config => {
    const DEV = localStorage.getItem('DEV');
    config.data = {
        ...config.data,
        dev: DEV, // Cambia esto según tus necesidades
    };
    return config;
});

export default AxioInstance;